export const FETCH_RATING_PRODUCT = 'RatingProduct/FETCH';
export const FETCH_RATING_PRODUCT_SUCCESS = 'RatingProduct/FETCH_SUCCESS';
export const FETCH_RATING_PRODUCT_FAIL = 'RatingProduct/FETCH_FAIL';

/* eslint-disable */
const RatingProductReducer = (state = {}, action = {}) => {
  switch (action.type) {
    case FETCH_RATING_PRODUCT:
      return {
        ...state,
        [action.payload.sku]: {
          isLoading: true,
          isLoaded: false,
        },
      };
    case FETCH_RATING_PRODUCT_SUCCESS:
      return {
        ...state,
        [action.payload.sku]: {
          isLoading: false,
          isLoaded: true,
          ...action.payload.data,
        },
      };
    case FETCH_RATING_PRODUCT_FAIL:
      return {
        ...state,
        [action.payload.sku]: {
          isLoaded: false,
          isLoading: false,
          error: action.error,
        },
      };
    default:
      return { ...state };
  }
};

export default RatingProductReducer;
